import { IconButtonOwnProps } from "@mui/material/IconButton";
import { useColorScheme } from "@mui/material/styles";
import { memo, useCallback } from "react";

import AppIcon from "@/components/Core/AppIcon";
import HeaderIconButton from "@/components/Core/HeaderIconButton";
import { useTranslate } from "@/hooks";

const ColorModeIcon = (props: IconButtonOwnProps) => {
  const t = useTranslate();
  const { mode, systemMode, setMode } = useColorScheme();
  const resolvedMode = (systemMode || mode) as "light" | "dark";
  const dark = resolvedMode === "dark";

  const handleClick = useCallback(() => {
    setMode(dark ? "light" : "dark");
  }, [dark, setMode]);

  return (
    <HeaderIconButton
      data-screenshot="toggle-mode"
      onClick={handleClick}
      // Named for what pressing it does, not for the scheme the page is in.
      label={t(dark ? "header.light-mode" : "header.dark-mode")}
      {...props}
      sx={{
        // The icon turns as it changes, so the press reads as a switch thrown.
        "& .app-icon": {
          transition: "transform 320ms cubic-bezier(0.2, 0.8, 0.2, 1)",
          transform: dark ? "rotate(0deg)" : "rotate(-180deg)",
        },
        "@media (prefers-reduced-motion: reduce)": {
          "& .app-icon": { transition: "none" },
        },
      }}
    >
      <AppIcon name={dark ? "sun" : "moon"} size={20} />
    </HeaderIconButton>
  );
};

export default memo(ColorModeIcon);
